import {
  AD_CAMPAIGN_QSP,
  IS_EMBEDDED,
  PAI_AD_ID_QSP,
  PAY_FRIENDS_P2P_EXPERIMENT_QSP,
  PF_TOKEN_QSP,
  SRC_QSP,
} from 'utils/queryParamHelpers';
import { getValueFromStorage } from 'utils/storage/storageHelper';

import { REFERRAL_TOKEN, REFERRER_NAME } from './storageConsts';

const { DEPLOYMENT_ENVIRONMENT, OPTIMIZELY_KEY, SERVER_URL, DEV_ENV } =
  window.Chime.config;

/**
 * All possible DEPLOYMENT_ENVIRONMENT values:
 * - dev
 * - feature
 * - qa
 * - prod
 */
export const IS_DEV_ENV = DEPLOYMENT_ENVIRONMENT === 'dev';
export const IS_PROD_ENV = DEPLOYMENT_ENVIRONMENT === 'prod';
export const IS_QA_ENV = DEPLOYMENT_ENVIRONMENT === 'qa';
export const IS_FEATURE_ENV = DEPLOYMENT_ENVIRONMENT === 'feature';

/**
 * BASE_API_URL is the Back End API Enrollment Client hits
 *
 * We'll use SERVER_URL if specified in config. By default, we'll use empty string '' since in
 * live environments, React client is served from the same domain as the BASE_API_URL
 */
export const BASE_API_URL = SERVER_URL || '';

/**
 * !!!
 * These urls are being used in project-otter enrollment flow for checking if user is on policies page based on 'policies' string check
 * so please do not update it before contacting with mobile team first (file: project-otter/src/screens/LoggedOut/screens/Register/RegisterWebView.tsx line 65)
 * !!!
 */

/**
 * BASE_POLICIES_URL is the URL for policies and disclaimers.
 */
export const BASE_POLICIES_URL = 'https://chime.com/policies';

// Dynamic Consts (builds on other consts)

// Consumer application endpoints
export const USER_ENTITY_BASE_URL = `${BASE_API_URL}/enrollment/user`;
export const GET_USER_DATA_URL = `${BASE_API_URL}/enrollment/current.json`;
export const ZIPCODE_CITY_STATE_URL = `${BASE_API_URL}/member/validate_zip`;

export const REQUEST_ENROLLMENT_START_COUNT_URL = `${BASE_API_URL}/enrollment/start`;

// Consumer Persona endpoints
export const PERSONA_INQUIRY_URL = `${BASE_API_URL}/identification/inquiry`;
export const PERSONA_VERIFICATION_URL = `${BASE_API_URL}/identification/verification`;
export const VERIFY_SCAN_ID_URL = `${BASE_API_URL}/enrollment/scan_id/verify`;
// Consumer promo code verification check
export const PROMO_CODE_VERIFY_URL = `${BASE_API_URL}/enrollment/promo_code/verify`;

// Third party endpoints
let SMARTY_AUTOSUGGEST_URL = `https://fe-proxy.chime.com/lookup`;
if (IS_DEV_ENV) {
  SMARTY_AUTOSUGGEST_URL = `https://us-autocomplete-pro.api.smartystreets.com/lookup`;
}

export { SMARTY_AUTOSUGGEST_URL };

/** Optimizely URL format: https://cdn.optimizely.com/datafiles/${env_specific_api_key}.json
 *  We determine the Optimizely Datafile URL we use by the following:
 *     Local, Dev, and QA environments --> Dev Fullstack Project - Dev key.
 *     Stage environment --> Dev Fullstack Project - Stage key.
 *     Production environment --> Optimizely Fullstack Project (only one key).
 *
 */
export const OPTIMIZELY_URL = `https://cdn.optimizely.com/datafiles/${OPTIMIZELY_KEY}.json`;

// Pay anyone
export const IS_PAY_ANYONE_SOURCE = SRC_QSP === 'pay_anyone_v2';
export const IS_RECEIVE_FROM_ANYONE_SOURCE = SRC_QSP === 'receive_from_anyone';

export const IS_PAY_ANYONE_REFERRAL =
  IS_PAY_ANYONE_SOURCE && AD_CAMPAIGN_QSP === 'ch_pai' && PAI_AD_ID_QSP;

export const IS_PAY_ANYONE_P2P =
  (PF_TOKEN_QSP &&
    (IS_PAY_ANYONE_SOURCE || IS_RECEIVE_FROM_ANYONE_SOURCE) &&
    PAY_FRIENDS_P2P_EXPERIMENT_QSP === 'true') ||
  IS_PAY_ANYONE_REFERRAL;

// Referral Specific Enrollment
const referralCookiesExist =
  !!getValueFromStorage(REFERRAL_TOKEN) && !!getValueFromStorage(REFERRER_NAME);

export const IS_REFERRAL_SPECIFIC_ENROLLMENT = referralCookiesExist;

// Chime App download links
export const IOS_DOWNLOAD_LINK = IS_PAY_ANYONE_P2P
  ? 'https://chime-ios.onelink.me/psdT/f93972e9'
  : 'https://itunes.apple.com/us/app/chime-rewards/id836215269?mt=8';
export const ANDROID_DOWNLOAD_LINK = IS_PAY_ANYONE_P2P
  ? 'https://chime-android.onelink.me/QVOi/f93972e9'
  : 'https://play.google.com/store/apps/details?id=com.onedebit.chime';

export const DEFAULT_TIMEOUT_DURATION = 3000;

// Used in the Unemployment Assistant
export const ENROLLMENT_REL_URL = IS_DEV_ENV ? '/' : '/enroll';

const EMBEDDED_DD_LOGIN_REL_URL = IS_DEV_ENV
  ? `${BASE_API_URL}/link/show_direct_deposit_info`
  : '/link/show_direct_deposit_info';

const SIGNED_OFF_DD_LOGIN_REL_URL = IS_DEV_ENV
  ? `${BASE_API_URL}/member/sign_in#`
  : '/member/sign_in#';

export const DD_LOGIN_REL_URL = IS_EMBEDDED
  ? EMBEDDED_DD_LOGIN_REL_URL
  : SIGNED_OFF_DD_LOGIN_REL_URL;

export const UNEMPLOYMENT_REL_URL = IS_DEV_ENV
  ? 'http://localhost:8899'
  : '/unemployment';

export const INVITE_FRIENDS_TERMS =
  'https://www.chime.com/invite-friends-terms-and-conditions-100-evergreen-august-2021/';

export const URGENCY_OFFER_INVITE_FRIENDS_TERMS =
  'https://www.chime.com/invite-friends-terms-and-conditions-125-urgency-offer-receiver-mar-2024/';

export { DEV_ENV, DEPLOYMENT_ENVIRONMENT };

// Additional referrer urls
export const REFERRER_URL_EXCLUSIONS = [
  '/meet-my-paycheck-fb',
  '/meet-my-paycheck-g',
  '/meet-my-paycheck-ef',
  '/my-paycheck-your-checking-supercharged-fb',
  '/my-paycheck-your-checking-supercharged-g',
  '/apply-debit-2/',
  '/mypay-waitlist',
];
